export default function minDetailProductThumbnail(product) {
  const {
    detail: {
      brand, flags, typeName,
    },
    id,
    identifier,
    urlTemplate,
    imagery,
    pricing,
    meta,
  } = product.product;
  const minDetailProduct = {
    detail: {
      brand, flags, typeName,
    },
    id,
    identifier,
    urlTemplate,
    imagery,
    pricing,
    meta,
  };
  return minDetailProduct;
}
